import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import PublicLayout from "@/components/lux/PublicLayout";
import Home from "@/pages/public/Home";
import CityPage from "@/pages/public/CityPage";
import AreaPage from "@/pages/public/AreaPage";
import ProfilePage from "@/pages/public/ProfilePage";
import SafetyPage from "@/pages/public/SafetyPage";
import HelpPage from "@/pages/public/HelpPage";
import ReportPage from "@/pages/public/ReportPage";
import LegalPage from "@/pages/public/LegalPage";
import NotFoundPage from "@/pages/public/NotFoundPage";
import SavedPage from "@/pages/public/SavedPage";

import AdvertiserLayout from "@/pages/advertiser/AdvertiserLayout";
import LoginPage from "@/pages/advertiser/LoginPage";
import RegisterPage from "@/pages/advertiser/RegisterPage";
import TwoFactorPage from "@/pages/advertiser/TwoFactorPage";
import DashboardPage from "@/pages/advertiser/DashboardPage";
import VerificationPage from "@/pages/advertiser/VerificationPage";
import ListingEditorPage from "@/pages/advertiser/ListingEditorPage";
import StoriesPage from "@/pages/advertiser/StoriesPage";
import NotificationsPage from "@/pages/advertiser/NotificationsPage";
import SupportPage from "@/pages/advertiser/SupportPage";
import AccountPage from "@/pages/advertiser/AccountPage";
import SecurityPage from "@/pages/advertiser/SecurityPage";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";
import AdminCasesPage from "@/pages/admin/AdminCasesPage";
import AdminCaseDetailPage from "@/pages/admin/AdminCaseDetailPage";
import AdminAuditPage from "@/pages/admin/AdminAuditPage";
import AdminTermsPage from "@/pages/admin/AdminTermsPage";
import AdminAccountsPage from "@/pages/admin/AdminAccountsPage";
import AdminVerificationsPage from "@/pages/admin/AdminVerificationsPage";
import AdminStaffPage from "@/pages/admin/AdminStaffPage";
import AdminAppealsPage from "@/pages/admin/AdminAppealsPage";

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/profile/:slug" element={<ProfilePage />} />
            <Route path="/saved" element={<SavedPage />} />
            <Route path="/safety" element={<SafetyPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/report" element={<ReportPage />} />
            <Route path="/terms" element={<LegalPage slug="terms" />} />
            <Route path="/privacy" element={<LegalPage slug="privacy" />} />
            <Route path="/cookies" element={<LegalPage slug="cookies" />} />
            <Route path="/online-safety" element={<LegalPage slug="online-safety" />} />
            <Route path="/complaints" element={<LegalPage slug="complaints" />} />
            <Route path="/posting-guidelines" element={<LegalPage slug="posting-guidelines" />} />
            {/* Cities: London (main), Birmingham, Manchester. Static routes above win over these dynamic ones. */}
            <Route path="/:city" element={<CityPage mode="city" />} />
            <Route path="/:city/browse" element={<CityPage mode="browse" />} />
            <Route path="/:city/:area" element={<AreaPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          <Route path="/advertiser" element={<AdvertiserLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="2fa" element={<TwoFactorPage />} />
            <Route path="verify" element={<VerificationPage />} />
            <Route path="listing" element={<ListingEditorPage />} />
            <Route path="stories" element={<StoriesPage />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route path="support" element={<SupportPage />} />
            <Route path="appeal" element={<SupportPage />} />
            <Route path="account" element={<AccountPage />} />
            <Route path="security" element={<SecurityPage />} />
          </Route>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboardPage />} />
            <Route path="login" element={<AdminLoginPage />} />
            <Route path="cases" element={<AdminCasesPage />} />
            <Route path="cases/:id" element={<AdminCaseDetailPage />} />
            <Route path="appeals" element={<AdminAppealsPage />} />
            <Route path="accounts" element={<AdminAccountsPage />} />
            <Route path="verifications" element={<AdminVerificationsPage />} />
            <Route path="terms" element={<AdminTermsPage />} />
            <Route path="staff" element={<AdminStaffPage />} />
            <Route path="audit" element={<AdminAuditPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#151517",
            color: "#F2F2F4",
            border: "1px solid #2A2A2E",
          },
        }}
      />
    </>
  );
}
